import { useEffect, useState } from "react";
import { CONTACT_OPEN_EVENT } from "@/lib/contactForm";
import ContactInquiryModal from "@/components/contact/ContactInquiryModal";

export default function ContactInquiryProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [openCount, setOpenCount] = useState(0);

  useEffect(() => {
    const handleOpen = () => {
      setOpenCount((count) => count + 1);
      setOpen(true);
    };
    window.addEventListener(CONTACT_OPEN_EVENT, handleOpen);
    return () => window.removeEventListener(CONTACT_OPEN_EVENT, handleOpen);
  }, []);

  return (
    <>
      {children}
      <ContactInquiryModal open={open} onOpenChange={setOpen} formKey={openCount} />
    </>
  );
}
